/* theme-pce.js — Quick-Add fuer die Enhanced Product Card.
   Ausgelagert aus snippets/product-card-enhanced.liquid (27.07.2026).
   Wichtig: frueher wurde dieser document-Listener pro Karte registriert,
   ein Klick loeste dadurch so viele /cart/add.js-Requests aus wie
   Produktkarten auf der Seite standen. Der Guard verhindert das dauerhaft. */
(function () {
  if (window.__slPceQuickAdd) return;
  window.__slPceQuickAdd = true;

// Quick Add to Cart functionality
document.addEventListener('click', function(e) {
  const addBtn = e.target.closest('.pce-add-to-cart');
  if (!addBtn) return;
  
  e.preventDefault();
  
  const variantId = addBtn.dataset.variantId;
  if (!variantId) return;
  
  // Show loading state
  const originalContent = addBtn.innerHTML;
  addBtn.innerHTML = '<i class="fa-solid fa-spinner fa-spin"></i>';
  addBtn.disabled = true;

  // Fliegender Punkt zum Warenkorb (Helper aus theme.js)
  if (typeof window.slFlyToCart === 'function') window.slFlyToCart(addBtn);
  
  // Add to cart
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1
    })
  })
  .then(response => {
    if (!response.ok) return response.json().then(err => { throw new Error(err.description || 'Add to cart failed'); });
    return response.json();
  })
  .then(data => {
    // Success animation
    addBtn.innerHTML = '<i class="fa-solid fa-check"></i> <span>Hinzugefügt!</span>';
    addBtn.style.background = '#30f070';
    
    // Zaehler und Drawer ueber die API aus theme.js.
    //
    // Vorher stand hier `typeof openCartDrawer === 'function'` — die Funktion
    // lebt aber in der IIFE von theme.js und ist keine globale, die Bedingung
    // war also immer false. Der Artikel landete im Warenkorb, der Drawer ging
    // nie auf: fuer den Kunden sah Quick-Add wie ein No-op aus.
    //
    // Der Zaehler wurde ausserdem blind um 1 hochgezaehlt statt den echten
    // Stand zu lesen — bei mehreren Tabs oder Varianten lief er auseinander.
    const cart = window.StrainLabCart;
    if (cart && typeof cart.updateCount === 'function') {
      cart.updateCount();
    } else {
      const cartCount = document.querySelector('[data-cart-count]');
      if (cartCount) cartCount.textContent = (parseInt(cartCount.textContent, 10) || 0) + 1;
    }

    if (cart && typeof cart.open === 'function') {
      setTimeout(() => cart.open(), 500);
    }

    setTimeout(() => {
      addBtn.innerHTML = originalContent;
      addBtn.style.background = '';
      addBtn.disabled = false;
    }, 2000);
  })
  .catch(error => {
    console.error('Error:', error);
    addBtn.innerHTML = '<i class="fa-solid fa-times"></i> <span>Fehler</span>';
    addBtn.style.background = '#e03090';
    
    setTimeout(() => {
      addBtn.innerHTML = originalContent;
      addBtn.style.background = '';
      addBtn.disabled = false;
    }, 2000);
  });
});
/* Varianten-Chips in der Card: Klick setzt aktive Variante,
   aktualisiert Add-to-Cart-Button (data-variant-id) und Preisanzeige. */
document.addEventListener('click', function (e) {
  const chip = e.target.closest('.pce-variant-chip');
  if (!chip || chip.disabled || chip.classList.contains('pce-variant-more')) return;

  e.preventDefault();

  const card = chip.closest('.product-card-enhanced');
  if (!card) return;

  card.querySelectorAll('.pce-variant-chip').forEach(c => c.classList.toggle('is-active', c === chip));

  const addBtn = card.querySelector('.pce-add-to-cart');
  if (addBtn) addBtn.dataset.variantId = chip.dataset.variantId;

  const priceEl = card.querySelector('.pce-price-current');
  if (priceEl && chip.dataset.price) priceEl.textContent = chip.dataset.price;
});

/* Hover-Bild erst bei Bedarf laden. Spart auf der Startseite bis zu 10,
   auf Kollektionsseiten bis zu 24 Bild-Requests - auf Mobil komplett. */
document.addEventListener('mouseover', function (e) {
  var t = e.target;
  if (!t || !t.closest) return;
  var card = t.closest('.product-card-enhanced');
  if (!card) return;
  var img = card.querySelector('img[data-pce-hover]');
  if (!img) return;
  img.src = img.getAttribute('data-pce-hover');
  img.removeAttribute('data-pce-hover');
}, { passive: true });

})();
